import { render, staticRenderFns } from "./tablesPegawai.vue?vue&type=template&id=6593752d&scoped=true"
import script from "./tablesPegawai.vue?vue&type=script&lang=js"
export * from "./tablesPegawai.vue?vue&type=script&lang=js"
import style0 from "./tablesPegawai.vue?vue&type=style&index=0&id=6593752d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6593752d",
  null
  
)

export default component.exports